export default __webpack_public_path__ + "static/media/socashless-logo-1.9f5dcefb.png";